/** What a weather card, its frame and its paint read, once. */
import type { Translator } from "@/i18n";
import type weatherEn from "@/i18n/messages/frames-weather/en";
import { parseLabel, parseTemp } from "./weather-content";
import { daysFrom, type WeatherDay } from "./weather-days";

export interface WeatherFields {
  place: string | null;
  temp: number | null;
  condition: string | null;
  high: number | null;
  low: number | null;
  days: WeatherDay[];
}

export function weatherFields(source: Record<string, unknown>): WeatherFields {
  return {
    place: parseLabel(source.place),
    temp: parseTemp(source.temp),
    condition: parseLabel(source.condition),
    high: parseTemp(source.high),
    low: parseTemp(source.low),
    days: daysFrom(source.days),
  };
}

/** Whether there is weather to show; else the card and its window are plain. */
export function hasWeather(fields: WeatherFields): boolean {
  return (
    fields.place !== null ||
    fields.temp !== null ||
    fields.condition !== null ||
    fields.high !== null ||
    fields.low !== null ||
    fields.days.length > 0
  );
}

/** "H:16° L:8°", from the bounds that are known. */
export function weatherRange(
  { high, low }: WeatherFields,
  t: Translator<typeof weatherEn>,
): string {
  return [
    high !== null && t("highTemp", { temp: high }),
    low !== null && t("lowTemp", { temp: low }),
  ]
    .filter(Boolean)
    .join(" ");
}
